module.exports = __webpack_public_path__ + "img/arjen-auto.f5098b7b.jpg";